<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L4wJiT/tc-custom/9781488061066.jpg?1726444246248" alt="This image is the cover for the book Baby's Defender"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Baby's Defender
      </h1>
      <p class="bookDescription body article font2">
        <b>In this inspirational romantic suspense, a military widow and her newborn go under the protection of a handsome former Army ranger.</b><br/><br/>Westley Foster is the first person Cady Long turns to when she’s attacked in her new home. As a security expert, her late husband’s military buddy is the perfect choice to guard her and her baby daughter . . . and figure out how the attacker is getting inside. But as the unknown enemy closes in, can West keep them safe long enough to catch her would-be killer?<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jill Elizabeth Nelson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6521b95c